<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`公司利润表_车队列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'dwages',
      getListUrl: 'fleet',
      breadcrumb: [
        { name: '财务管理', path: '/finance/companyProfit' },
        { name: '公司利润表', path: '/finance/companyProfit' },
        // { name: '车队列表' },
      ],
      formInline: { month: undefined },
      formCtrl: [
        {
          label: "月份：",
          placeholder: "请选择月份",
          keyName: "month",
          type: 'month',
        },
      ],
      cols: [
        { prop: "month", label: "月份", slot: "month" },
        { prop: 'fleet_name', label: '车队长', minwidth: 120 },
        { prop: 'car_count', label: '车辆数量', minwidth: 120 },
        { prop: 'allorder', label: '公司运费', minwidth: 120 },
        { prop: 'infreight', label: '司机运费', minwidth: 120 },
        { prop: 'groprofit', label: '公司利润', minwidth: 120 },
        { prop: 'avg_profit', label: '单车平均利润', minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ month, fleet }) => {
            this.$router.push(
              `/finance/companyProfitSingleCar?month=${month}&fleet=${fleet}`
            );
          },
        },
      ],
      getTotalProperty: ['car_count', 'allorder', 'infreight', 'groprofit', 'avg_profit',],
      baseParams: ['month'],
    };
  },
  methods: {
    getTotal(param) {
      const {
        columns,
        data
      } = param;
      // console.log(param)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 && column.type !== 'selection') {
          // console.log({...column}, {...data})
          sums[index] = '合计';
          return;
        }
        if (columns[0].type === 'selection' && index === 1) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          this.getTotalProperty.includes(column.property)
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            // console.log(value, prev, curr,11111)
            if (column.label == "车辆数量") {
              if (!isNaN(value)) {
                return Number(prev) + Number(curr);
              } else {
                return prev;
              }
            } else {
              if (!isNaN(value)) {
                return this.keep2(Number(prev) + Number(curr));
              } else {
                return this.keep2(prev);
              }
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
  },
  mounted() {
    // console.log({ ...this.formInline })
    const { month } = this.$route.query
    this.MONTH = this.formInline.month = month + ''
    // console.log({ ...this.formInline })
    this.getList()
  },
};
</script>
